module.exports = __webpack_public_path__ + "static/media/map-mark.0a0d9f7b.svg";